"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Editor;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _editor = require("../../components/visualizations/editor");

var _propTypes = require("../prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Editor(_ref) {
  var options = _ref.options,
      onOptionsChange = _ref.onOptionsChange;

  var updateOptions = updates => {
    onOptionsChange((0, _lodash.merge)({}, options, updates));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Switch, {
    "data-test": "PivotEditor.HideControls",
    id: "pivot-show-controls",
    defaultChecked: !options.controls.enabled,
    onChange: enabled => updateOptions({
      controls: {
        enabled: !enabled
      }
    })
  }, "Show Pivot Controls")), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Switch, {
    id: "pivot-show-row-totals",
    defaultChecked: options.rendererOptions.table.rowTotals,
    onChange: rowTotals => updateOptions({
      rendererOptions: {
        table: {
          rowTotals
        }
      }
    })
  }, "Show Row Totals")), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Switch, {
    id: "pivot-show-column-totals",
    defaultChecked: options.rendererOptions.table.colTotals,
    onChange: colTotals => updateOptions({
      rendererOptions: {
        table: {
          colTotals
        }
      }
    })
  }, "Show Column Totals")));
}

Editor.propTypes = _propTypes.EditorPropTypes;
//# sourceMappingURL=Editor.js.map